import { Google, Pixall } from '../analytics/index.js';
import { sanitizeValue } from './helpers/index.js';
import { vehicleSearchTransformer } from '../transformers/pixall/DataLayerTransformer';

/**
 * @summary Sends articles carousel impression on SRP
 */
export function articlesCarouselImpression(metadata, option) {
  if (metadata === void 0) {
    metadata = {};
  }
  const {
    dataLayer,
    data = {}
  } = metadata;
  Google.sendImpressions(metadata, {
    eventElement: 'article',
    eventResult: 'article-carousel'
  }, option);
  Pixall.sendImpression(metadata, {
    eventSource: 'vehicle',
    feature: 'article',
    label: 'article-carousel',
    listingType: 'article',
    ...data,
    cdl: {
      eventProperties: {
        vehicleSearch: vehicleSearchTransformer(dataLayer)
      }
    }
  }, option);
  return {};
}

/**
 * @summary Sends articles carousel click on SRP
 */
export function articleCarouselClick(_ref, option) {
  let {
    data = {},
    dataLayer = {}
  } = _ref;
  const {
    contentType = '',
    ...rest
  } = data;
  Google.sendClickEvent({
    eventElement: 'article',
    eventResult: `cta::article-carousel::${sanitizeValue(contentType)}`
  }, option);
  Pixall.sendClickEvent({
    eventSource: 'vehicle',
    feature: 'article',
    label: `cta_article-carousel_${sanitizeValue(contentType)}`,
    listingType: 'article',
    ...rest,
    cdl: {
      eventProperties: {
        vehicleSearch: vehicleSearchTransformer(dataLayer)
      }
    }
  }, dataLayer, option);
  return {};
}
export default {
  articleCarouselClick,
  articlesCarouselImpression
};